import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { PROFA2_REFERENCE_DATA_URL } from '../../../constants';
import axios from 'axios';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getProfA2ReferenceData = createAsyncThunk(
  'stop/getProfA2ReferenceData',
  async (params) => {
    const config = {
      headers: {
        Authorization: params,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .get(PROFA2_REFERENCE_DATA_URL, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });

    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const profA2ReferenceDataSlice = createSlice({
  name: 'stop/profA2ReferenceData',
  initialState: null,
  reducers: {
    resetProfA2ReferenceData: () => null,
  },
  extraReducers: {
    [getProfA2ReferenceData.fulfilled]: (state, action) => action.payload,
  },
});

export const { resetProfA2ReferenceData } =
profA2ReferenceDataSlice.actions;

export default profA2ReferenceDataSlice.reducer;
